import Reveal from "@/components/base/Reveal";

interface SectionHeadingProps {
  badge: string;
  badgeIcon?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  tone?: "light" | "dark";
  badgeTone?: "primary" | "accent" | "secondary";
}

const LIGHT_BADGE: Record<string, string> = {
  primary: "bg-primary-50 text-primary-700",
  accent: "bg-accent-50 text-accent-700",
  secondary: "bg-secondary-50 text-secondary-700",
};

export default function SectionHeading({
  badge,
  badgeIcon = "ri-sparkling-2-line",
  title,
  description,
  align = "center",
  tone = "light",
  badgeTone = "primary",
}: SectionHeadingProps) {
  const isDark = tone === "dark";
  const wrapper = align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl";

  const badgeClass = isDark
    ? "border border-background-50/15 bg-background-50/5 text-accent-300"
    : LIGHT_BADGE[badgeTone];

  return (
    <Reveal>
      <div className={wrapper}>
        <span
          className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-wide ${badgeClass}`}
        >
          <i className={badgeIcon} aria-hidden="true"></i>
          {badge}
        </span>
        <h2
          className={`mt-5 font-heading text-2xl font-bold tracking-tight md:text-4xl ${
            isDark ? "text-background-50" : "text-foreground-950"
          }`}
        >
          {title}
        </h2>
        {description ? (
          <p
            className={`mt-4 text-base leading-relaxed ${
              isDark ? "text-background-200" : "text-foreground-600"
            }`}
          >
            {description}
          </p>
        ) : null}
      </div>
    </Reveal>
  );
}